import { useState } from "react"
import { Button, Card, CardBody, CardHeader, CardTitle, Container, Form, FormGroup, Input, Label } from "reactstrap"
import Utils from "../../Utils"
import { useDispatch } from "react-redux"
import { checkToken } from "../../datastore/actions/usuarioActions"

const DEFAULT_FORM_STATE = {
    DNI: "",
    password: ""
}

const Login = () => {

    const dispatch = useDispatch()

    const [form, setForm] = useState(DEFAULT_FORM_STATE)

    const [error, setError] = useState(null)

    const handleInputChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const onToken = async pretoken => {
        try {
            const { data } = await Utils.API.exchangeToken(pretoken)
            //
            Utils.SetAuthToken(data.token)
            //
            dispatch(
                checkToken()
            )
        } catch(err) {
            Utils.AlertError(err, `Error al intercambiar token de sesión`)
        }
    }

    const onSubmit = async event => {
        event.preventDefault()
        try {
            const { data } = await Utils.API.Login(form.DNI, form.password)
            onToken(data.token)
        } catch(err) {
            Utils.AlertError(err, `Error al iniciar sesión`)
        }
    }

    return(
        <Container className="mt-4 justify-content-center align-items-center">
            <Card>
                <CardHeader className="bg-primary text-white h5">Iniciar Sesión</CardHeader>
                <CardBody>
                    <Form onSubmit={onSubmit}>
                        <FormGroup>
                            <Label>DNI:</Label>
                            <Input onChange={handleInputChange} value={form.DNI} name="DNI" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Contraseña:</Label>
                            <Input onChange={handleInputChange} type="password" value={form.password} name="password" />
                        </FormGroup>
                        <Button size="lg" color="success" block>Ingresar</Button>
                    </Form>
                </CardBody>
            </Card>
        </Container>
    )
}

export default Login